export default __webpack_public_path__ + "static/media/double-moon-2.6135cb2e.webp";